module.exports = __webpack_public_path__ + "../resources/img/go.55e1a10f.png";